import { RootState } from 'app/store';

export const selectUnreadNotifications = (state: RootState) =>
  state.notifications.unreadNotifications;

export const selectReadNotifications = (state: RootState) =>
  state.notifications.readNotifications;

export const selectUnreadNotificationsToShow = (state: RootState) =>
  state.notifications.unreadNotificationsToShow;

export const selectUnreadNotificationsCount = (state: RootState) => {
  return state.notifications.unreadCount;
};

export const selectNotificationsLoading = (state: RootState) =>
  state.notifications.isLoading;
